module.exports = __webpack_public_path__ + "pnskfsquadron/img/m-book-hero5.png?d8541266";